import React from 'react';
import OrderWorkunit from 'types/entities/OrderWorkunit';

const DiscountCell = React.memo((row: OrderWorkunit) => (
  <>{row?.discount > 0 ? <span className="ellipsis">{row.discount.toFixed(2)} %</span> : <div>-</div>}</>
));

export default DiscountCell;
